import ErrorPage from './ErrorPage.container'

export default ErrorPage
